"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsBase = require("@telus-uds/components-base");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * A footer for PreviewCard that composes author and date in a standard way
 *
 * @TODO
 * Add same locale-based date formatting as StoryCard when ready.
 * Get locale based on decision of https://github.com/telus/universal-design-system/issues/715
 */const AuthorDate = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    author,
    date
  } = _ref;
  const {
    separatorColor: color
  } = (0, _componentsBase.useThemeTokens)('PreviewCard', {}, {});
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_componentsBase.StackWrap, {
    space: 2,
    ref: ref,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Typography, {
      variant: {
        size: 'small',
        colour: 'secondary'
      },
      children: author
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Typography, {
      variant: {
        size: 'small'
      },
      tokens: {
        color
      },
      children: "\xB7"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Typography, {
      variant: {
        size: 'small',
        colour: 'secondary'
      },
      children: date
    })]
  });
});
AuthorDate.displayName = 'AuthorDate';
AuthorDate.propTypes = {
  /**
   * Name of the author
   */
  author: _propTypes.default.string.isRequired,
  /**
   * Date of the post
   */
  date: _propTypes.default.string.isRequired
};
var _default = exports.default = AuthorDate;